import React, { useState } from 'react';
import { Typography, Modal, Form } from 'antd';
import { Button, Input, notification } from '@gamesb42/ui-kit';
import { useHistory } from 'react-router-dom';
import urls from 'constants/urls';
import { resetPassword } from 'api/users';
import EmailSentModal from 'pages/LogIn/components/EmailSentModal';

const { Title, Text, Link } = Typography;

const ExpiredLinkScreen: React.FC = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [sentEmail, setSentEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRequestNewLink = async (values: { email: string }) => {
    setLoading(true);
    try {
      await resetPassword({ email: values.email });

      // Закрываем модалку с формой и показываем модалку успеха
      setShowEmailModal(false);
      setSentEmail(values.email);
      setShowSuccessModal(true);
      form.resetFields();
    } catch (error) {
      console.error('Reset password error:', error);
      notification.error({
        theme: 'dark',
        message: 'Failed to Send Reset Email',
        description: 'Failed to send password reset email. Please try again.',
        placement: 'bottomLeft',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    // Возвращаемся на страницу логина
    history.push(urls.getAuth());
  };

  return (
    <div style={{ textAlign: 'left' }}>
      <Title level={2} style={{ marginBottom: '20px', color: '#090909' }}>
        Password reset link expired
      </Title>

      <Text style={{ display: 'block', marginBottom: '32px', color: '#606176', fontSize: '16px' }}>
        For your security, password reset links are only valid for a limited time
      </Text>

      <Button
        type="primary"
        size="large"
        violet
        style={{
          color: '#fff',
          width: '178px',
          marginBottom: '24px',
        }}
        onClick={() => setShowEmailModal(true)}
      >
        Request a new link
      </Button>

      <div>
        <Link
          onClick={() => history.push(urls.getAuth())}
          style={{ color: '#5227cb', fontSize: '16px', cursor: 'pointer' }}
        >
          Back to Sign In
        </Link>
      </div>

      {/* Модалка для ввода email */}
      <Modal
        open={showEmailModal}
        onCancel={() => {
          setShowEmailModal(false);
          form.resetFields();
        }}
        footer={null}
        width={520}
        centered
        okButtonProps={{ style: { display: 'none' } }}
      >
        <div style={{ padding: '24px 0' }}>
          <Title level={3} style={{ marginBottom: '16px', color: '#090909' }}>
            Request a new link
          </Title>

          <Text style={{ display: 'block', marginBottom: '32px', color: '#606176', fontSize: '14px' }}>
            Enter your email address and we'll send you a new password reset link.
          </Text>

          <Form form={form} layout="vertical" onFinish={handleRequestNewLink}>
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please input your email!' },
                { type: 'email', message: 'Please enter a valid email!' },
              ]}
            >
              <Input label="Email" placeholder="Enter your email" size="large" />
            </Form.Item>

            <div style={{ display: 'flex', gap: '16px', justifyContent: 'flex-end', marginTop: '32px' }}>
              <Button
                size="large"
                onClick={() => {
                  setShowEmailModal(false);
                  form.resetFields();
                }}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" loading={loading} size="large" violet style={{ color: '#fff' }}>
                Send Reset Link
              </Button>
            </div>
          </Form>
        </div>
      </Modal>

      {/* Модалка успешной отправки */}
      <EmailSentModal visible={showSuccessModal} email={sentEmail} onClose={handleSuccessModalClose} />
    </div>
  );
};

export default ExpiredLinkScreen;
